<template>
  <div>
    <div class="cb-content" :class="{'cb-content--full-width':isExpiryOrTag}">
      <template v-if="pmType == 'card'">
        <span
          class="cb-content__icon"
          aria-hidden="true"
          :class="getCardClass(selectedCardType)"
          :style="themeColor"
        ></span>
        <span v-if="!selectedCardType">{{st('credit_card')}}</span>
        <span class="cb-content__text">{{st('ending')}} {{last4}}</span>
      </template>
      <template v-if="pmType == 'paypal_express_checkout'">
        <i
          class="icon-paypal cb-content__icon cb-content__icon--sm"
          aria-hidden="true"
          :style="themeColor"
        ></i>
        <span class="cb-content__text">{{paypal_email}}</span>
      </template>
      <template v-if="pmType == 'venmo'">
        <i
          class="icon-venmo cb-content__icon cb-content__icon--sm"
          aria-hidden="true"
          :style="themeColor"
        ></i>
        <span class="cb-content__text">{{venmo_username}}</span>
      </template>
      <template v-if="pmType == 'amazon_payments'">
        <template v-if="isPersistent">
          <i class="icon-amazon-pay cb-content__icon cb-content__icon--sm" aria-hidden="true"></i>
          <span class="cb-content__text">{{amazon_email}}</span>
        </template>
        <template v-else>
          <i class="icon-amazon-pay cb-content__icon cb-content__icon--sm" aria-hidden="true"></i>
          <span class="cb-content__text">{{cmt('pm.amazon_payments')}}</span>
        </template>
      </template>
      <template v-if="pmType == 'apple_pay'">
        <template v-if="isPersistent">
          <i
            class="icon-apple-pay-textual-border cb-content__icon cb-content__icon--xl"
            aria-hidden="true"
          ></i>
          <span class="cb-content__text">{{cmt('pm.apple_pay')}}</span>
        </template>
        <template v-else>
          <i
            class="icon-apple-pay-textual-border cb-content__icon cb-content__icon--xl"
            aria-hidden="true"
          ></i>
        </template>
      </template>
      <template v-if="pmType == 'ideal'">
        <p class="cb-content__text">{{owner_name}}</p>
        <p class="cb-content__text">{{owner_email}}</p>
        <span class="icon-iDeal" aria-hidden="true"></span>
        <template v-if="isPersistent">
          <span class="cb-content__text">{{iDeal_bank}}</span>
        </template>
        <template v-else>
          <span class="cb-content__text cb-fw--semi_bold">{{cmt('pm.ideal')}}</span>
          <span class="cb-content__text cb-fs--ti cb-fw--semi_bold">({{cmt('pm.ideal_desc')}})</span>
        </template>
      </template>
      <template v-if="pmType == 'klarna_pay_now'">
        <template>
          <p class="cb-content__text">{{owner_name}}</p>
          <p class="cb-content__text">{{owner_email}}</p>
          <p class="cb-content__text">{{owner_country}}</p>
          <span class="icon-klarna" aria-hidden="true"></span>
          <span class="cb-content__text cb-fw--semi_bold">{{cmt('pm.klarna_pay_now')}}</span>
        </template>
      </template>
      <template v-if="pmType == 'sofort'">
        <template>
          <p class="cb-content__text">{{owner_name}}</p>
          <p class="cb-content__text">{{owner_email}}</p>
          <p class="cb-content__text">{{owner_country}}</p>
          <span class="icon-sofort" aria-hidden="true"></span>
          <span class="cb-content__text cb-fw--semi_bold">{{cmt('pm.sofort')}}</span>
          <span class="cb-content__text cb-fs--ti cb-fw--semi_bold">({{cmt('pm.sofort_desc')}})</span>
        </template>
      </template>
      <template v-if="pmType == 'bancontact'">
        <template>
          <p class="cb-content__text">{{owner_name}}</p>
          <p class="cb-content__text">{{owner_email}}</p>
          <p class="cb-content__text">{{owner_country}}</p>
          <template v-if="last4">
            <span class="icon-bancontact" aria-hidden="true"></span>
            <span class="cb-content__text">{{st('ending')}} {{last4}}</span>
          </template>
          <template v-else>
            <span class="icon-bancontact" aria-hidden="true"></span>
            <span class="cb-content__text cb-fw--semi_bold">{{cmt('pm.bancontact')}}</span>
          </template>
          <div class="cb-content__text cb-fs--ti cb-fw--semi_bold">({{cmt('pm.bancontact_desc')}})</div>
        </template>
      </template>
      <template v-if="pmType == 'google_pay'">
        <template v-if="isPersistent">
          <span class="icon-google-pay" aria-hidden="true"></span>
          <span class="cb-content__text">{{st('ending')}} {{last4}}</span>
        </template>
        <template v-else>
          <i class="icon-google-pay" aria-hidden="true" v-if="!last4"></i>
          <span class="cb-content__text cb-fw--semi_bold" v-if="!last4">{{cmt('pm.google_pay')}}</span>
          <div class="cb-content" v-if="last4">
            <span
              class="cb-content__icon"
              aria-hidden="true"
              :class="{'icon-cc-visa' : selectedCardType == 'VISA', 'icon-cc-amex': selectedCardType == 'AMEX', 'icon-cc-mastercard-new': selectedCardType == 'MASTERCARD', 'icon-cc-discover': selectedCardType == 'DISCOVER'}"
              :style="themeColor"></span>
            <span v-if="!selectedCardType">{{st('credit_card')}}</span>
            <span class="cb-content__text">{{st('ending')}} {{last4}}</span>
          </div>
        </template>
      </template>
      <template v-if="pmType == 'upi'">
        <template v-if="isPersistent">
           <span class="icon-upi" aria-hidden="true"></span>
          <span class="cb-content__text">{{upiId}}</span>
        </template>
        <template v-else>
          <span class="icon-upi icon-upi--full" aria-hidden="true"></span>
          <span class="cb-content__middle">{{cmt('pm.upi')}}</span>
          <div class="cb-content cb-content--b-sm" :key="index" v-for="(details, index) in bankAccountInputFields()">
            <div class="cb-content__left" v-bind:key="index">{{details[0]}}</div>
            <div class="cb-content__right cb-content__bold" v-bind:key="index">
              {{details[1]}}
            </div>
          </div>
        </template>
      </template>
      <template v-if="isOfflinePmType">
        <i :class="[offlinePmIcon, 'cb-content__icon cb-content__icon--sm']" aria-hidden="true"></i>
        <span class="cb-content__text">{{offlinePmDisplayName}}</span>
        <div class="cb-content__text" v-if="!isPortal">{{offlinePmDesc}}</div>
      </template>
      <template v-if="pmType == 'giropay'">
        <template>
          <span class="icon-giropay small" aria-hidden="true"></span>
          <span class="cb-content__text cb-fw--semi_bold">{{cmt('pm.giropay')}}</span>
          <span class="cb-content__text cb-fs--ti cb-fw--semi_bold">({{cmt('pm.giropay_desc')}})</span>
        </template>
      </template>
      <template v-if="isDirectDebitOrInstantBanking">
        <template v-if="isPersistent">
          <template v-if="bankAccountLast4">
            <i
              class="cb-content__icon"
              style="font-size:16px;"
              :class="directDebitPersistIcons"
              aria-hidden="true"
            ></i>
            <span class="cb-content__text">{{st('ending')}} {{bankAccountLast4}}</span>
          </template>
          <template v-else>
            <div
              class="cb-content cb-content--b-sm"
              :key="index"
              v-for="(details, index) in bankAccountOutputFields()"
            >
              <div class="cb-content__left" v-bind:key="index">{{details[0]}}</div>
              <div class="cb-content__right cb-content__bold" v-bind:key="index">{{details[1]}}</div>
            </div>
          </template>
          <span
            class="cb-content__flag"
            v-if="hasPendingVerification"
          >{{cmt('direct_debit.pending_verification')}}</span>
        </template>
        <template v-else>
          <i
            :class="directDebitTransientIcons"
            aria-hidden="true"
          ></i>
          <template v-if="isPlaid && bankAccountLast4">
            <span class="cb-content__text" >{{st('ending')}} {{bankAccountLast4}}</span>
          </template>
          <template v-else>
             <span class="cb-content__middle">{{directDebitHeader}}</span>
          </template>
          <div
            class="cb-content cb-content--b-sm"
            :key="index"
            v-for="(details, index) in bankAccountInputFields()"
          >
            <div class="cb-content__left" v-bind:key="index">{{details[0]}}</div>
            <div class="cb-content__right cb-content__bold" v-bind:key="index">{{details[1]}}</div>
          </div>
        </template>
      </template>
      <template v-if="pmType == 'netbanking_emandates'">
        <template>
          <span class="icon-bank small" aria-hidden="true"></span>
          <span class="cb-content__text cb-fw--semi_bold">{{netbankingData.bank}}</span>
          <span class="cb-content__text cb-fs--ti cb-fw--semi_bold">(**{{netbankingData.last2}})</span>
        </template>
      </template>
      <div class="cb-tf--right">
        <span
          class="cb-label"
          v-if="showPrimaryTag"
          :style="backgroundColor"
        >{{t('payment_method_tag.primary')}}</span>
        <span
          class="cb-label cb-label__secondary"
          v-if="showBackupTag"
        >{{t('payment_method_tag.backup')}}</span>
      </div>
      <div v-if="cardExpiry && this.t('card.expired') && t('card.expiring')" class="cb-note--margin">
      <template v-if="cardExpiry == 'expired'">
          <cb-notes :type="'error'" :message="t('card.expired',{card_expiry: this.cardExpiryDate})"></cb-notes>
      </template>
      <template v-else-if="cardExpiry == 'expiring'">
        <cb-notes :type="'warning'" :message="t('card.expiring', { card_expiry: this.cardExpiryDate})"></cb-notes>
      </template>
      <template v-else>
        <span>{{cardExpiry}}</span>
      </template>
    </div>
    <span v-else-if="cardExpiry" class="cb-content__flag">
        <span v-if="cardExpiry == 'expired'">{{st('card_expired')}}</span>
        <span v-else-if="cardExpiry == 'expiring'">{{st('card_expiring')}}</span>
        <span v-else>{{cardExpiry}}</span>
    </span>
    </div>
  </div>
</template>
<script type="text/javascript">
import { mapGetters } from "vuex";
import PaymentMethodDisplayer from "@/utils/payment-method-displayer";
import cardFormatter from "@/utils/card-formatter";
import Notes from "@/components/collections/elements/Notes";
import PaymentHelper from "@/utils/payment-helper"
import CountryCodeList from "@/utils/country-code-list.js";
export default {
  props: ["persistentPaymentMethod", "transientPaymentMethod", "showRole"],
  components: {
    "cb-notes": Notes
  },
  computed: {
    isPersistent() {
      return this.persistentPaymentMethod ? true : false;
    },
    selectedCardType() {
      // Change this way of writing code
      return (
        (this.persistentPaymentMethod &&
          this.persistentPaymentMethod.card &&
          this.persistentPaymentMethod.card.brand) ||
        this.cardType
      );
    },
    pmType() {
      return (
        (this.persistentPaymentMethod && this.persistentPaymentMethod.type) ||
        (this.transientPaymentMethod && this.transientPaymentMethod.type)
      );
    },
    additional_info(){
      let pm = this.pm_by_type(this.pmType);
      return pm && pm.configuration && pm.configuration.additional_info
    },
    isPortal() {
      return this.hosted_page_type == 'portal';
    },
    isOfflinePmType() {
      return PaymentHelper.isOfflinePaymentMethod(this.pmType);
    },
    offlinePmIcon() {
      return PaymentHelper.getOfflinePaymentMethodIcon(this.pmType);
    },
    offlinePmDisplayName() {
      if(this.pmType == 'boleto') {
        const pm = this.pm_by_type(this.pmType);
        if(this.persistentPaymentMethod && this.persistentPaymentMethod.boleto) {
          return (PaymentHelper.getPaymentMethodDisplayName(pm) || '')  + `(${this.cmt("boleto.tax_id_ending_with")} ${this.persistentPaymentMethod.boleto.last4})`
        } else {
          return PaymentHelper.getPaymentMethodDisplayName(pm);
        }
      }
      if(this.isPortal) {
        return this.persistentPaymentMethod && (this.persistentPaymentMethod.display_name || this.persistentPaymentMethod.name);
      } else {
        let pm = this.pm_by_type(this.pmType);
        return PaymentHelper.getPaymentMethodDisplayName(pm);
      }
    },
    offlinePmDesc() {
      return this.t(`review.opm.${this.pmType}.desc`);
    },
    isDirectDebitOrInstantBanking() {
      return ['direct_debit','faster_payments','pay_to','sepa_instant_transfer'].includes(this.pmType);
    },
    directDebitPersistIcons() {
      return {'icon-bank' : this.isDirectDebitBankIcon, 
        'icon-direct-debit' : this.isDirectDebitIcon, 
        'icon-sepa': this.isDirectDebitSepaIcon,
        'icon-faster-payments': this.isFasterPaymentsIcon,
        'icon-payto': this.isPayToIcon
      }
    },
    directDebitTransientIcons() {
      return {'icon-bank cb-content__icon cb-content__icon--sm' : this.isDirectDebitBankIcon, 
        'icon-direct-debit  cb-content__icon cb-content__icon--st' : this.isDirectDebitIcon, 
        'icon-sepa cb-content__icon cb-content__icon--st': this.isDirectDebitSepaIcon,
        'icon-faster-payments cb-content__icon cb-content__icon--st': this.isFasterPaymentsIcon,
        'icon-payto cb-content__icon cb-content__icon--st': this.isPayToIcon
      }
    },
    isDirectDebitIcon() {
      return !(this.isDirectDebitBankIcon || this.isDirectDebitSepaIcon 
                  || this.isFasterPaymentsIcon || this.isPayToIcon)
    },
    isDirectDebitBankIcon() {
      return !this.instantDirectDebit && ['ACH', 'BECS', 'PAD', 'BECS(NZ)'].includes(this.scheme);
    },
    isDirectDebitSepaIcon() {
      return ['SEPA'].includes(this.scheme);
    },
    isFasterPaymentsIcon() {
      return this.instantDirectDebit && ['faster_payments'].includes(this.pmType);
    },
    isPayToIcon() {
      return this.instantDirectDebit && ['pay_to'].includes(this.pmType);
    },
    directDebitHeader() {
      if(this.instantDirectDebit) {
        switch (this.pmType) {
          case 'faster_payments':
          case 'sepa_instant_transfer':
          case 'pay_to':
            return this.cmt(`pm.${this.pmType}`);
        }
      }
      switch (this.scheme) {
        case "ACH":
        case "PAD":
          if(this.additional_info) {
            return this.additional_info.sub_header;
          }
          return this.st('pm.ach');
        case "BECS":
        case "BECS(NZ)":
        case "SEPA":
        case "BACS":
        case "Autogiro":
          return this.st("pm.direct_debit");
        default:
          return this.st("pm.direct_debit");
      }
    },
    instantDirectDebit() {
      let pm = this.pm_by_type(this.pmType);
      return pm && pm.configuration && pm.configuration.open_banking_enabled;
    },
    scheme() {
      let pm = this.pm_by_type(this.pmType);
      if (pm && pm.configuration) {
        return pm.configuration.scheme;
      } else if (pm && pm.plaid_config){
        return "ACH"; // Plaid is kind of ACH
      } else if (
        this.isPersistent &&
        this.persistentPaymentMethod.gateway == "stripe"
      ) {
        // stripe ach not allowed in checkout, so you didn't get configuration
        return "ACH";
      }
      return '';
    },
    isPlaid() {
      let pm = this.pm_by_type(this.pmType);
      return pm && pm.plaid_config;
    },
    gatewayName() {
      return this.pm_by_type(this.pmType).gateway_name;
    },
    last4() {
      return (
        (this.persistentPaymentMethod &&
          this.persistentPaymentMethod.card &&
          this.persistentPaymentMethod.card.last4) ||
        this.transientPaymentMethodLast4
      );
    },
    bankAccountLast4() {
      return (
        (this.persistentPaymentMethod &&
        this.persistentPaymentMethod.bank_account &&
        this.persistentPaymentMethod.bank_account.last4) ||
        (this.isPlaid && this.plaidLast4 )
      );
    },
    plaidLast4() {
      return (
        this.$store.getters.payment_data &&
        this.$store.getters.payment_data.last4
      );
    },
    gpayLast4() {
      return (this.$store.getters.payment_data &&
          this.$store.getters.payment_data.cardInfo &&
          this.$store.getters.payment_data.cardInfo.last4);
    },
    gpayCardType() {
      return (this.$store.getters.payment_data &&
          this.$store.getters.payment_data.cardInfo &&
          this.$store.getters.payment_data.cardInfo.brand);
    },
    hasPendingVerification() {
      return (
        this.persistentPaymentMethod &&
        this.persistentPaymentMethod.status == "pending_verification"
      );
    },
    paypal_email() {
      return (
        (this.persistentPaymentMethod &&
          this.persistentPaymentMethod.paypal &&
          this.persistentPaymentMethod.paypal.email) ||
        (this.transientPaymentMethod &&
          this.transientPaymentMethod.meta &&
          this.transientPaymentMethod.meta.payer_email)
      );
    },

    venmo_username(){
      return (
        this.persistentPaymentMethod?.venmo?.username ||
        this.persistentPaymentMethod?.venmo?.user_name ||
        this.transientPaymentMethod?.meta?.payer_username
      );
    },
    upiId() {
      return (
        this.persistentPaymentMethod &&
        this.persistentPaymentMethod.upi &&
        this.persistentPaymentMethod.upi.vpa
      );
    },
    amazon_email() {
      return (
        this.persistentPaymentMethod &&
        this.persistentPaymentMethod.amazon_payment &&
        this.persistentPaymentMethod.amazon_payment.email
      );
    },
    iDeal_bank() {
      return (
        this.persistentPaymentMethod &&
        this.persistentPaymentMethod.issuerBank &&
        this.persistentPaymentMethod.issuerBank.name
      );
    },
    owner_name() {
      return this.transientPaymentMethod && this.transientPaymentMethod.owner_name
    },
    owner_email() {
      return this.transientPaymentMethod && this.transientPaymentMethod.owner_email
    },
    owner_country() {
      if(this.transientPaymentMethod && this.transientPaymentMethod.owner_country) {
        let country = CountryCodeList.filter(f => f.value == this.transientPaymentMethod.owner_country)[0];
        return country && country.display_name;
      }
    },
    transientPaymentMethodLast4() {
      if(this.pmType == 'google_pay') {
        return this.gpayLast4;
      }
      let tmp =
        this.transientPaymentMethod && this.transientPaymentMethod.tmp_token
          ? this.tmp_storage_get(this.transientPaymentMethod.tmp_token)
          : this.transientPaymentMethod;

      return (
        tmp &&
        tmp.number &&
        tmp.number.substring(tmp.number.length - 4, tmp.number.length)
      );
    },
    cardType() {
      if(this.pmType == 'google_pay') {
        return this.gpayCardType;
      }
      let tmp =
        this.transientPaymentMethod && this.transientPaymentMethod.tmp_token
          ? this.tmp_storage_get(this.transientPaymentMethod.tmp_token)
          : this.transientPaymentMethod;
      return tmp && cardFormatter.cardType(tmp.number);
    },
    ...mapGetters(["tmp_storage_get", "pm_by_type", "primary_pm", "backup_pm", "hosted_page_type"]),
    cardExpiry() {
      if (
        !(this.persistentPaymentMethod && this.persistentPaymentMethod.card)
      ) {
        return;
      }
      return this.persistentPaymentMethod.status != "valid"
        ? this.persistentPaymentMethod.status
        : false;
    },
    paymentMethod() {
      return this.persistentPaymentMethod || this.transientPaymentMethod;
    },
    pmId() {
      return this.paymentMethod && this.paymentMethod.id;
    },
    cardExpiryDate() {
      return (
        this.paymentMethod.type === "card" &&
        this.paymentMethod.card.expiry_month +
          "/" +
          this.paymentMethod.card.expiry_year
      );
    },
    isExpiryOrTag() {
      return this.cardExpiry || this.showPrimaryTag || this.showBackupTag;
    },
    showPrimaryTag() {
      return this.showRole && this.primary_pm && this.primary_pm.id == this.pmId;
    },
    showBackupTag() {
      return this.showRole && this.backup_pm && this.backup_pm.id == this.pmId;
    },
    netbankingData() {
      const data = {};
      if(this.paymentMethod.type === "netbanking_emandates") {
        if(this.persistentPaymentMethod && this.persistentPaymentMethod.bank_account) {
          data.last2 = this.persistentPaymentMethod.bank_account.last4.slice(-2);
          data.bank = this.persistentPaymentMethod.bank_account.bank_name;
        } else {
          const formData = this.transientPaymentMethod;
          data.last2 = `${formData.account_number}`.slice(-2);
          data.bank = formData.bank_name || formData.bank;
        }
      }
      return data;
    }
  },
  methods: {
    bankAccountOutputFields() {
      return PaymentMethodDisplayer.bankAccountOutputFields()
        .map(f => {
          if (f.displayer) {
            return [
              f.name,
              f.displayer(this.persistentPaymentMethod.bank_account[f.field])
            ];
          }
          return [f.name, this.persistentPaymentMethod.bank_account[f.field]];
        })
        .filter(
          f => !!f[1] && f[1] != "not_applicable" && f[1] != "Not_applicable"
        );
    },
    bankAccountInputFields() {
      return PaymentMethodDisplayer.bankAccountInputFields(this.scheme, this.gatewayName)
        .map(f => {
          if (f.displayer) {
            return [
              this.$store.getters.get_text(f.label_key),
              f.displayer(this.transientPaymentMethod[f.field])
            ];
          }
          return [
            this.$store.getters.get_text(f.label_key),
            this.transientPaymentMethod[f.field]
          ];
        })
        .filter(f => !!f[1]);
    },
    getCardClass(type) {
      return cardFormatter.getCardClass(type);
    }
  }
};
</script>
